import api from "../api/api";
import { V2_BASE_URL } from "../api/bases";
import { getPracticeId } from "../config/practice";

/*
 * Unified Inbox calls (owner 10-20, Step 1), all v2 and pinned like the fax
 * and forms code (`_gw: "v2-pinned"`: no v1/v2 routing rule, no v1 fallback,
 * never trips the v2 circuit breaker; the routes exist on v2 only):
 *   inboxCounts       GET  /v1/{pid}/inbox/counts
 *   listRequests      GET  /v1/{pid}/inbox/requests?status=&q=&source=&page=&page_size=
 *   updateItem        PUT  /v1/{pid}/inbox/item/{source}/{source_id}  {status?, assignee_userid?, note?}
 *   itemCandidates    GET  /v1/{pid}/inbox/item/{source}/{source_id}/candidates
 *   linkItem          POST /v1/{pid}/inbox/item/{source}/{source_id}/link  {patientid}
 *   sendIntakeLink    POST /v1/{pid}/website-requests/{id}/send-intake-link  (the Web Requests tab's)
 * JSON bodies only (no FormData here).
 */
const V2 = { baseURL: V2_BASE_URL, _gw: "v2-pinned" };
const base = () => `/v1/${getPracticeId()}/inbox`;
const enc = (s) => encodeURIComponent(String(s));

export function inboxCounts() {
  return api.get(`${base()}/counts`, V2);
}

export function listRequests({ status = "open", q = "", source = "", page = 1, pageSize = 50 } = {}) {
  const params = { status, page, page_size: pageSize };
  if (q && q.trim()) params.q = q.trim();
  if (source) params.source = source;
  return api.get(`${base()}/requests`, { ...V2, params });
}

export function updateItem(item, changes) {
  return api.put(`${base()}/item/${enc(item.source)}/${enc(item.source_id)}`, changes, V2);
}

export function itemCandidates(item) {
  return api.get(`${base()}/item/${enc(item.source)}/${enc(item.source_id)}/candidates`, V2);
}

export function linkItem(item, patientid) {
  return api.post(`${base()}/item/${enc(item.source)}/${enc(item.source_id)}/link`, { patientid }, V2);
}

export function sendIntakeLink(item) {
  return api.post(`/v1/${getPracticeId()}/website-requests/${enc(item.source_id)}/send-intake-link`, {}, V2);
}

// The server's message for a 4xx, else `fallback`.
export function inboxErrorMessage(error, fallback) {
  const d = error && error.response && error.response.data;
  const msg = d && (d.message || d.detail);
  return typeof msg === "string" && msg ? msg : fallback;
}
